import React from "react";
import { User as UserModel } from "../../models/user";
import FooterBlock from "../../components/Footer/Footer";
import Badges from "./components/Badges";
import LoggedOutView from "../LoggedOutPage/LoggedOutPage";

interface BadgesPageProps {
  loggedInUser: UserModel | null;
}

const BadgesPage = ({ loggedInUser }: BadgesPageProps) => {
  return (
    <div className="startBellowNavbar pageBlock">
      {loggedInUser ? (
        <>
          <Badges />
          <FooterBlock />
        </>
      ) : (
        <LoggedOutView />
      )}
    </div>
  );
};

export default BadgesPage;
